import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let URL = "https://benefacto-backend.developer-ourbase-camp.com/api/";

export const ReceiverApi = createAsyncThunk("reciever/detail", async () => {
	try {
		const { data } = await axios.get(`${URL}receivers/get-receivers`);
		return data;
	} catch (err) {
		return err.message;
	}
});
